import React from "react"
import ImageLoader from "../../components/misc/ImageLoader"
import DefaultUserIcon from "material-ui/svg-icons/action/account-circle"
import SystemIcon from "material-ui/svg-icons/hardware/desktop-mac"
import { grey100, blue800, lightBlue100 } from "material-ui/styles/colors"
import { ETimeoffStatus, IBasicUser, ITimeoffNote } from "../../models"
import moment from "moment"
import strings from "../../localization/strings"
interface IProps {
  users: IBasicUser[]
  note: ITimeoffNote
}

const LeftNote: React.SFC<IProps> = (props: IProps) => {
  return (
    <div style={{ float: "left", display: "table", tableLayout: "fixed", marginBottom: 20, clear: "both" }}>
      <div style={{ display: "table-cell", verticalAlign: "top", width: 55, paddingTop: 18 }}>
        {props.note.UserId ?
          props.users.find((user) => user.Id === props.note.UserId).ProfileImageS3Url ?
            <ImageLoader
              url={props.users.find((user) => user.Id === props.note.UserId).ProfileImageS3Url}
              fixedHeight={75} avatar={true}
            /> :
            <DefaultUserIcon color={lightBlue100} style={{ width: 50, height: 50, marginLeft: -4, marginTop: -4 }} /> :
          <SystemIcon color={lightBlue100} style={{ width: 50, height: 50, marginLeft: -4, marginTop: -4 }} />
        }
      </div>
      <div style={{ display: "table-cell", verticalAlign: "top", padding: 0, position: "relative" as "relative" }}>
        <div  >
          <div style={{ color: blue800, fontSize: 11 }}>
            {`${props.note.UserName} - ${moment(props.note.DateTime).local().format("DD/MM/YYYY hh:mm A")} 
              (${props.note.StatusAssociatedWithNote === ETimeoffStatus.Requested ?
                strings.Requested :
                props.note.StatusAssociatedWithNote === ETimeoffStatus.Approved ?
                  strings.Approved :
                  props.note.StatusAssociatedWithNote === ETimeoffStatus.Applied ?
                    strings.Applied :
                    strings.Denied
              })`
            }
          </div>
          <div style={{ position: "relative", backgroundColor: grey100, padding: 10, borderRadius: 10 }}>
            <span style={{ width: 8, height: 8, backgroundColor: grey100, position: "absolute", left: -5, top: 16, transform: "rotate(45deg)" }} />
            {props.note.Note}
          </div>
        </div>
      </div>
    </div>
  )
}

export default LeftNote